import type {UserInterface} from '@interfaces/user'

interface LogbookEntryCreator {
  id: number
  identity_uuid?: string | null
  email?: string | null
}

// Since the tenants-service migration, currentUser.id comes from the
// organizations service while the entry payload carries pm-core's user id —
// two unrelated id spaces, so comparing them wrongly locks authors out of
// their own entries (AB#5668). identity_uuid is the one id both sides share,
// so it decides when both carry it; email, then the id, remain fallbacks for
// payloads and users without one.
export const isLogbookEntryCreator = (
  currentUser: UserInterface | null | undefined,
  creator: LogbookEntryCreator | null | undefined,
): boolean => {
  if (!currentUser || !creator) {
    return false
  }
  if (currentUser.identity_uuid && creator.identity_uuid) {
    return currentUser.identity_uuid === creator.identity_uuid
  }
  if (currentUser.email && creator.email) {
    return currentUser.email.trim().toLowerCase() === creator.email.trim().toLowerCase()
  }
  return currentUser.id === creator.id
}
